import React from "react";
import BasePaywall from "app/components/paywalls/BasePaywall";
import spacelimitIcon from "app/images/paywall-body-icon-space-limit.png";

type PropsDef = {
  show?: boolean;
  onClose?: () => void;
};

export default function PostMediaPaywall({ show, onClose }: PropsDef) {
  return (
    <BasePaywall
      show={show}
      onClose={onClose}
      title="Upgrade to CoachNow PRO"
      image={spacelimitIcon}
      returnUrl="/spaces"
      featureName="Post Media"
    />
  );
}
